import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import { ApplicationContext } from '@contexts/ApplicationContext'
import { track } from '@utils/tracking'
import { TimeValue, TimeValuePropType } from '@hooks/useTimeValue'

const TABS_PRESENT_VALUE_INDEX = 1
const TABS_FUTURE_VALUE_INDEX = 0

export const TimeValueToggle = ({ setTimeValue, timeValue }) => {
  const { trackingDetails } = useContext(ApplicationContext)

  return (
    <Tabs
      className='app-tabs'
      selectedIndex={timeValue === TimeValue.present ? TABS_PRESENT_VALUE_INDEX : TABS_FUTURE_VALUE_INDEX}
      onSelect={() => {}}
    >
      <TabList className='app-tabs__list flex'>
        <Tab
          onClick={() =>{
            setTimeValue(TimeValue.future)
            track('Toggle future value', trackingDetails)
          }}
          className='app-tabs__list-item'
          selectedClassName='app-tabs__list-item--selected'>Future value</Tab>
        <Tab
          onClick={() =>{
            setTimeValue(TimeValue.present)
            track('Toggle present value', trackingDetails)
          }}
          className='app-tabs__list-item'
          selectedClassName='app-tabs__list-item--selected'>Present value</Tab>
      </TabList>
      {/* The scenario header uses a Tab component as a toggle and therefore does not have panels */}
      <TabPanel />
      <TabPanel />

    </Tabs>
  )
}

TimeValueToggle.propTypes = {
  setTimeValue: PropTypes.func.isRequired,
  timeValue: TimeValuePropType.isRequired
}
